import { combineReducers } from "redux";
import appReducer from "./reducer/app";

const rootReducer = combineReducers({
  app: appReducer,
});

const initialState = rootReducer(undefined, { type: "" });

const resetStateReducer = (state = initialState, action) => {
  if (action.type === "RESET_STATE") {
    state = initialState;
  }
  return rootReducer(state, action);
};

export default resetStateReducer;
